import React from "react";
import { TestimonialsBoxContainer } from "./TestimonialBox.style";

const TestimonialBox = ({ text, name, role }) => {
    return (
        <TestimonialsBoxContainer>
            <div className="reviews_item">
                <div className="reviews_boxed">
                    <p>{text}</p>
                </div>
                <p className="reviwer_name">{name}</p>
                <span className="redfont">{role}</span>
            </div>
        </TestimonialsBoxContainer>
    );
};

export default TestimonialBox;
